import React from "react";

import { colors } from "@zapalacorp/tokens";

import { Button } from "../../../../../../../../../components/Form";
import { Color } from "../../../../../../../../../components/Form/Button";
import IconAdd from "../../../../../../../../../components/Generic/Icons/Add";
import { Label } from "./styles";

type Props = {
  disabled?: boolean;
  label: string;
  onClick: () => void;
};

const NewRecordButton: React.FC<Props> = ({ label, disabled = false, onClick }) => {
  return (
    <Button
      disabled={disabled}
      onClick={onClick}
      customColor={Color.BRAND}
      startIcon={<IconAdd height={21} width={21} color={colors.white} />}
    >
      <Label>{label}</Label>
    </Button>
  );
};

export { NewRecordButton };
